import SelectTableFilter from 'components/atoms/select-table-filter'
import React from 'react'
import { Table } from 'reactstrap'
import PropTypes from 'prop-types'
import PriceUtil from 'utils/price-util'
import ScraperOrderStatusBadge from 'domains/scraper-product/atoms/customer-order-status-badge'
import { ORDER_STATUS } from 'domains/scraper-product/constants'
import RowButton from 'components/atoms/row-button'

const propTypes = {
  buttonText       : PropTypes.string,
  buttonColour     : PropTypes.string,
  isButtonDisabled : PropTypes.func,
  onButtonClick    : PropTypes.func
}

const filterPropTypes = {
  column: PropTypes.object
}

const actionCellPropTypes = {
  cell: PropTypes.shape({
    row: PropTypes.shape({
      original: PropTypes.object
    })
  })
}

/**
 * Columns definition for Merchant Table
 * @param {string} buttonText - The text that appears at the button on each row
 * @param {string} buttonColour - Bootstrap button type class name (eg. primary)
 * @param {Function} isButtonDisabled - function that will check whether the button on particular row is disabled
 * @param {Function} onButtonClick - function that will run when the button is clicked
 */
const customerOrderItemScraperTableColumns = ({ onChangeOrderStatus }) => {
  const OrderStatusFilter = ({ column }) => {
    const options = Object.keys(ORDER_STATUS).map((key) => (
      {
        label : ORDER_STATUS[key],
        value : ORDER_STATUS[key]
      }
    ))
    return (
      <SelectTableFilter reactTableColumn={ column } options={ options } />
    )
  }
  OrderStatusFilter.propTypes = filterPropTypes


  const ScraperOrderStatusCell = (row) => <ScraperOrderStatusBadge order_status={ row.cell.value } />

  const ImageCell = (row) => <img style={{ width: '8rem' }} src={ row.cell.value } alt={ row.row.original.name } />

  const UrlCell = (row) => <a href={ row.cell.value } target='_blank'  rel="noreferrer"> website  </a>

  const TextWrapCell = (row) => <div className='text-wrap'> { row.cell.value } </div>

  const PriceCell = (row) => (
    <Table>
      <tbody>
        <tr>
          <th scope='row'>Price</th>
          <td>{ PriceUtil.format(row.row.original.price) }</td>
        </tr>
        <tr>
          <th scope='row'>Discount</th>
          <td>{ PriceUtil.format(row.row.original.discount_amount) }</td>
        </tr>
        <tr>
          <th scope='row'>Tax</th>
          <td>{ PriceUtil.format(row.row.original.tax_amount) }</td>
        </tr>
      </tbody>
    </Table>

  )

  const ActionCell = ({ cell: { row } }) => {
    const scraperId = row.original.scraper_product.id

    switch (row.original.scraper_product.customer_order_status) {
      case ORDER_STATUS.ORDERED:
        return (
          <RowButton
            data={{
              scraperId   : scraperId,
              orderStatus : ORDER_STATUS.PURCHASED_FROM_SITE
            }}
            color='primary'
            outline={ false }
            onClick={ onChangeOrderStatus }
            text="Mark as Purchased"
          />
        )
      case ORDER_STATUS.PURCHASED_FROM_SITE:
        return (
          <RowButton
            data={{
              scraperId   : scraperId,
              orderStatus : ORDER_STATUS.ARRIVED
            }}
            color='success'
            outline={ false }
            onClick={ onChangeOrderStatus }
            text="Mark as Arrived"
          />
        )
    }
    return null
  }
  ActionCell.propTypes = actionCellPropTypes

  return (
    [
      {
        Header         : 'ID',
        accessor       : 'id',
        disableFilters : true
      },
      {
        Header         : 'Image',
        accessor       : 'product.image',
        disableFilters : true,
        Cell           : ImageCell
      },
      {
        Header   : 'SKU',
        accessor : 'product.sku',
        id       : 'sku'
      },
      {
        Header   : 'Name',
        accessor : 'product.name',
        id       : 'name',
        Cell     : TextWrapCell
      },
      {
        Header         : 'Size',
        accessor       : 'product_dimension.size',
        disableFilters : true
      },
      {
        Header   : <>Order<br/> Number</>,
        accessor : 'order_number'
      },
      {
        Header         : 'Qty',
        accessor       : 'quantity',
        disableFilters : true
      },
      {
        Header         : 'Price',
        accessor       : 'price',
        disableFilters : true,
        Cell           : PriceCell
      },
      {
        Header         : 'Url',
        accessor       : 'scraper_product.product_url',
        disableFilters : true,
        Cell           : UrlCell
      },
      {
        Header   : <>Scraper<br/> Status</>,
        accessor : 'scraper_product.customer_order_status',
        id       : 'scraper_order_status',
        Filter   : OrderStatusFilter,
        Cell     : ScraperOrderStatusCell
      },
      {
        Header         : 'Action',
        id             : 'action',
        disableFilters : true,
        Cell           : ActionCell
      }
    ]
  )
}

customerOrderItemScraperTableColumns.propTypes = propTypes

export default customerOrderItemScraperTableColumns
